import { useMemo } from 'react';

import { CheckmarkOutline } from '@lyearn/icons';

import {
  ActionMenu,
  ActionMenuItemProps,
  ActionMenuItemType,
  ActionMenuProps,
} from '../ActionMenu';

type Props<T> = ActionMenuProps<T> & {
  defaultItemAppearance?: ActionMenuItemProps['appearance'];
  selectedId?: T;
};

function SelectionMenu<T extends string>(props: Props<T>) {
  const { defaultItemAppearance = 'primary', items: initialItems, selectedId, ...rest } = props;

  const items = useMemo<ActionMenuItemType[]>(
    () =>
      initialItems.map((item) => {
        if (item.type === 'divider' || item.type === 'label') {
          return item;
        }

        return item.id === selectedId
          ? { EndIcon: CheckmarkOutline, ...item }
          : { appearance: defaultItemAppearance, ...item };
      }),
    [defaultItemAppearance, initialItems, selectedId],
  );

  return <ActionMenu items={items} {...rest} />;
}

export default SelectionMenu;
